import { useState } from 'react'
import { UpdateBillingContactsForm } from './update-billing-contacts-form'
import BillingContactsBody from './billing-contacts-body'
import CustomEditButton from '../custom-edit-button'

export default function BillingContacts() {
  const [editState, setEditState] = useState(false)

  return (
    <div className="mx-auto w-full gap-4 flex flex-col">
      <div className="flex flex-row gap-4 justify-between">
        <h2 className="text-2xl font-bold ">Billing Contacts</h2>
        {!editState && (
          <CustomEditButton
            className="md:flex hidden"
            onClick={() => setEditState(true)}
          />
        )}
      </div>
      {editState ? (
        <UpdateBillingContactsForm
          onSuccess={() => setEditState(false)}
          onCancel={() => setEditState(false)}
        />
      ) : (
        <BillingContactsBody />
      )}
    </div>
  )
}
